import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* getLoginPortalLink(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "agency-settings/getInviteUrl/?role=tenant");

    yield put({
      type: Constants.GET_LOGIN_PORTAL_LINK_SUCCESS,
      payload: {
        link: res?.data?.url
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.url);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GET_LOGIN_PORTAL_LINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchGetLoginPortalLink() {
  yield takeEvery(Constants.GET_LOGIN_PORTAL_LINK_START, getLoginPortalLink);
}
